import { useState, useEffect } from 'react';
import { AlgorithmSettingsProps } from 'src/components/auto-shapes/types';
import {
  AutoShapeAlgorithmType,
  RoomDetection2DOptions,
} from 'src/gql/graphql';

export function RoomDetection2DSettings({
  value,
  onChange,
  onValidityChange,
}: AlgorithmSettingsProps<AutoShapeAlgorithmType.RoomDetection_2D>) {
  // Example implementation
  const [localValue, setLocalValue] = useState(value);

  const validateInput = (input: RoomDetection2DOptions) => {
    return false;
  };

  useEffect(() => {
    // Validate and update parent
    const isValid = validateInput(localValue);
    onValidityChange(isValid);
    onChange(localValue);
  }, [localValue, onChange, onValidityChange]);

  return (
    // Your settings UI here
    <div>Room Detection 2D Settings</div>
  );
}
